import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { ELECTRONIC_TRADING_TYPE_MAP_VALUE_TO_LABEL } from './constants';

const ID = 'electronicTradingType';

export const electronicTradingTypeTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery, config }) => {
    const electronicTradingType = getTermValue('electronic_trading')(jsonQuery);
    const isElectronicTradingEnabled = config.getStrict<boolean>('Audience.ElectronicTrading.Enabled');

    if (electronicTradingType === null || !isElectronicTradingEnabled) {
      return null;
    }

    const label = ELECTRONIC_TRADING_TYPE_MAP_VALUE_TO_LABEL[electronicTradingType];

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['electronic_trading'])(jsonQuery),
};
